import React, { memo } from 'react';
import { useTranslation } from 'next-i18next';

import { Icon } from 'components';

import styles from './InReviewCard.module.scss';

export const InReviewCard: React.FC = memo(() => {
  const [t] = useTranslation('event-dashboard');

  return (
    <>
      <div className={styles.InReviewCard}>
        <div className={styles.info}>
          <div>
            <Icon iconName="icon_info" size="large" />
          </div>
          <div className={styles.infoText}>
            <p className={styles.title}>{t('in-review.title')}</p>
            <p className={styles.desc}>{t('in-review.message')}</p>
          </div>
        </div>
      </div>
    </>
  );
});

InReviewCard.displayName = 'InReviewCard';
